/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Create_Folder_ValidationInputs */

const en_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a folder name`)
};

const fr_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un nom de dossier`)
};

const de_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen Ordnernamen ein.`)
};

const it_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per la cartella`)
};

const ru_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите название папки.`)
};

const es_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre de carpeta`)
};

const zh_cn2_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入文件夹名称`)
};

const ja_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ名を入力してください`)
};

const hi_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया फ़ोल्डर का नाम दर्ज करें`)
};

const pt_pt2_explorer_nav_create_folder_validation = /** @type {(inputs: Explorer_Nav_Create_Folder_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira o nome da pasta.`)
};

/**
* | output |
* | --- |
* | "Please enter a folder name" |
*
* @param {Explorer_Nav_Create_Folder_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_validation = /** @type {((inputs?: Explorer_Nav_Create_Folder_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_create_folder_validation(inputs)
	if (locale === "de") return de_explorer_nav_create_folder_validation(inputs)
	if (locale === "it") return it_explorer_nav_create_folder_validation(inputs)
	if (locale === "ru") return ru_explorer_nav_create_folder_validation(inputs)
	if (locale === "es") return es_explorer_nav_create_folder_validation(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_create_folder_validation(inputs)
	if (locale === "ja") return ja_explorer_nav_create_folder_validation(inputs)
	if (locale === "hi") return hi_explorer_nav_create_folder_validation(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_create_folder_validation(inputs)
	return en_explorer_nav_create_folder_validation(inputs)
});